module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gatsby Starter Tailwind CSS","short_name":"Gatsby Starter Tailwind CSS","start_url":"/","background_color":"#fff","theme_color":"#f56565","icon":"static/icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"29298f7d8117a56ec47726737cf5b463"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
